import {
  anItemMeta,
  anUpdateSuppressListItem,
  aSuppressListItem,
  mockUpdateSuppressedListItemOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateSuppressedListItemHandler = ({
  id,
  value,
  description,
  expiration,
}) => ({
  __typename: 'Mutation',
  updateSuppressListItem: {
    ...anUpdateSuppressListItem(),
    finishedProcessing: true,
    data: aSuppressListItem({
      id,
      value,
      expiration,
      meta: anItemMeta({ description }),
    }),
  },
});

export const handlers = [
  mockUpdateSuppressedListItemOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateSuppressListItem: anUpdateSuppressListItem({
            finishedProcessing: true,
          }),
        },
      });
    }
  ),
];
